import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoader } from "@react-three/fiber";
import { useProgress } from "@react-three/drei";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader";
import { MODEL_URL, HDRI_URL } from "../assets";
import "../styles/HomePage.css";

const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath("/draco/");
const extendGLTFLoader = (loader) => {
  loader.setDRACOLoader(dracoLoader);
};

// Rozpocznij wczytywanie modelu 3D i HDRI od razu po otwarciu strony startowej,
// zanim użytkownik jeszcze kliknie "Rozpocznij zwiedzanie" — dzięki temu
// w większości przypadków zasoby są już gotowe w chwili wejścia do eksploratora.
// (Te same klasy loaderów i URL-e co w rendererach = wspólny cache useLoader.)
useLoader.preload(GLTFLoader, MODEL_URL, extendGLTFLoader);
useLoader.preload(RGBELoader, HDRI_URL);

const BACKGROUND_IMAGES = [
  "/img/Wnetrze1.webp",
  "/img/Wnetrze2.webp",
  "/img/Wnetrze3.webp",
];

const SLIDE_INTERVAL_MS = 5000;

const HomePage = () => {
  const navigate = useNavigate();
  const { progress } = useProgress();
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % BACKGROUND_IMAGES.length);
    }, SLIDE_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  const handleEnterExplorer = () => {
    navigate("/explore");
  };

  const displayProgress = Math.min(Math.round(progress), 100);
  const isReady = displayProgress >= 100;

  return (
    <div className="home-container">
      <div className="home-background">
        {BACKGROUND_IMAGES.map((src, index) => (
          <div
            key={src}
            className={`home-background-slide ${
              index === activeSlide ? "is-active" : ""
            }`}
            style={{ backgroundImage: `url(${src})` }}
          />
        ))}
        <div className="home-background-overlay" />
      </div>

      <div className="home-footer">© Visualis Creative 2026</div>

      <div className="home-content">
        <span className="home-eyebrow">Mały Wersal</span>
        <h1>WERSJA ROZWOJOWA 1.0</h1>
        <p>
          Ukazana przestrzeń to wczesne demo technologiczne, stanowiące
          wstęp do produkcji projektu Mały Wersal odNowa, realizowanego przez
          stowarzyszenie Visualis Creative.
        </p>

        <button className="enter-button" onClick={handleEnterExplorer}>
          Rozpocznij zwiedzanie
        </button>

        <div className="model-loading">
          <div className="model-loading-track">
            <div
              className="model-loading-fill"
              style={{ width: `${displayProgress}%` }}
            />
          </div>
          <span className="model-loading-label">
            {isReady
              ? "Model 3D gotowy"
              : `Wczytywanie modelu 3D... ${displayProgress}%`}
          </span>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
